/**
 * Пастельная палитра (по образцу, который дал Дмитрий: #fdefe5/#e1e7ff/#f4e1ff)
 * — общая для карусели («Ролевые игры» на главном) и экрана-превью карточки:
 * на каждой карточке лёгкий градиент из двух оттенков одного тона, а не
 * плоская заливка. Разбирается по кругу (`index % PRACTICE_PALETTE.length`),
 * поэтому пока карточек не больше палитры, цвет ни разу не повторится;
 * больше — неизбежно пойдут повторы по кругу.
 *
 * Лиловый оттенок («Lilac») в палитре сознательно отсутствует — он был
 * слишком похож на градиент баннера «Свободная практика»
 * (`widgets/free-practice`), вместо него «Coral».
 */
export const PRACTICE_PALETTE = [
  { name: 'Peach', from: '#F8D6B8', to: '#FDEFE5' },
  { name: 'Periwinkle', from: '#C7D2FE', to: '#E1E7FF' },
  { name: 'Coral', from: '#FFBFA8', to: '#FFE3DC' },
  { name: 'Mint', from: '#B9F0D2', to: '#E0FAEF' },
  { name: 'Blush', from: '#FFC2D6', to: '#FFE1EC' },
  { name: 'Butter', from: '#FDEBAE', to: '#FFF6D9' },
  { name: 'Sky', from: '#B3E5FF', to: '#DCF3FF' },
  { name: 'Lime', from: '#D3F0A0', to: '#EAFAD1' },
  { name: 'Sand', from: '#E8D4B8', to: '#F5EBDD' },
  { name: 'Seafoam', from: '#B8ECDD', to: '#DFF7F1' },
] as const;

export type PracticePaletteEntry = (typeof PRACTICE_PALETTE)[number];

export function practicePaletteFor(index: number): PracticePaletteEntry {
  return PRACTICE_PALETTE[((index % PRACTICE_PALETTE.length) + PRACTICE_PALETTE.length) % PRACTICE_PALETTE.length]!;
}
